<template>
    <router-link v-if="action === 'router'"
        :to="route"  
        class="btn"  
        v-bind:class="type">
        <slot></slot>      
    </router-link>
    <button v-else
        class="btn"
        :type="action"
        v-bind:class="type"
        :disabled="disabled"
        @click="callback($event)"
        >
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'Btn',
    props: {        
        type:{
			type: String,
            required: false,
            default: () => ''
		},	
        action:{
			type: String,
            required: false,
            default: () => '.btn'
		},	
        disabled:{
			type: Boolean,
            required: false,
            default: () => false
		},	
        route:{
			type: String,
            required: false,
            default: () => '/'
		}
    },
    methods: {
        async callback(e) {
            this.$emit('click', e);
        }
    }
}
</script>

<style>
button {
    background-color: #e7e7e7 !important;
}

.btn {
    margin: 0.3em;
    display: inline-block !important;
    font-size: 2.3vh !important;
    font-weight: 400 !important;
    height: 3.125em !important;
    letter-spacing: 0.05em !important;
    line-height: 3.125em !important;
    padding: 0 1.5em !important;
    border-radius: 3px !important;
    border: 0 !important;
    opacity: 0.85 !important;
    cursor: pointer !important;
    text-align: center !important;
    text-decoration: none !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    -moz-appearance: none !important;
    -webkit-appearance: none !important;
    -ms-appearance: none !important;
    appearance: none !important;
    -moz-transition: 0.2s !important;
    -webkit-transition: 0.2s !important;
    -ms-transition: 0.2s !important;
    transition: 0.2s !important;
    z-index: 1;
}

        .btn:hover {
            opacity: 0.7 !important;
        }

        .btn:active {
            opacity: 1 !important;
        }
        
    .btn.danger {
        background-color: #ed4933 !important;
        box-shadow: none !important;
        color: #ffffff !important;
    }

    .btn.success {
        background-color: #007A5E !important;
        box-shadow: none !important;
        color: #ffffff !important;
    }

    .btn.green {
        background-color: #7fc241 !important;
        box-shadow: none !important;
        color: #ffffff !important;
    }

    .btn.warning {
        background-color: #f68b1e !important;
        box-shadow: none !important;
        color: #ffffff !important;
    }

    .btn.orange {
        background-color: #f1b016 !important;
        box-shadow: none !important;
        color: #ffffff !important;
    }

    .btn.white {
        background-color: #ffffff !important;
        box-shadow: none !important;
        opacity: 0.92 !important;
    }

        .btn.white:hover {
            opacity: 0.82 !important;
        }

        .btn.white:active {
            opacity: 1 !important;
        }

        .btn.white.green {
            color: #7fc241 !important;
        }

        .btn.white.success {
            color: #007A5E !important;
        }

        .btn.white.danger {
            color: #ed4933 !important;
        }

        .btn.white.warning {
            color: #f68b1e !important;
        }

        .btn.white.orange {
            color: #f1b016 !important;
        }

    .btn.menu {
        background-color: transparent !important;
        color: #fff !important;
        border: none !important;
        font-size: 1.3em !important;
        font-weight: lighter !important;
        position: fixed !important;
        right: 1em !important;
        top: 0.8em !important;
        -moz-filter: brightness(100%) !important;
        -webkit-filter: brightness(100%) !important;
        -ms-filter: brightness(100%) !important;
        filter: brightness(100%) !important;
        cursor: pointer !important;
        -moz-transition: 0.45s !important;
        -webkit-transition: 0.45s !important;
        -ms-transition: 0.45s !important;
        transition: 0.45s !important;
        z-index: 3 !important;
    }

        .btn.menu i:before {
            -moz-transition: 0.45s !important;
            -webkit-transition: 0.45s !important;
            -ms-transition: 0.45s !important;
            transition: 0.45s !important;
            opacity: 1 !important;
        }
        
        .btn.menu.active  {                    
            -moz-filter: brightness(0%) !important;
            -webkit-filter: brightness(0%) !important;
            -ms-filter: brightness(0%) !important;
            filter: brightness(0%) !important;
        }
        
        .btn.menu.active i:before {
            opacity: 0 !important;
        }

    .btn.slim {
        display: block !important;
        margin: 0 0 1em 0 !important;
        width: 100% !important;
    }

    .btn.s {
        font-size: 0.8em !important;
    }

    .btn.l {
        font-size: 1.35em !important;
    }

    .btn.disabled,
    .btn:disabled {
        opacity: 0.25 !important;
        pointer-events: none !important;
        -moz-pointer-events: none !important;
        -webkit-pointer-events: none !important;
        -ms-pointer-events: none !important;
    }
</style>
